// src/libs/socket.js
//
// Thin wrapper around the socket.io-client connection to the backend's
// real-time notification channel (see app/socket.js on the backend).
//
// IMPORTANT: the backend runs socket.io v2.5.1, not v3/v4 - "socket.io-client"
// in package.json is pinned to 2.5.0 to match. The v2 client does NOT support
// the `auth: { token }` connection option (that's a v3+ feature - on v2 it's
// silently ignored and the server never sees a token). Auth has to be passed
// via the `query` option instead, which the server's io.use() middleware
// reads from `socket.handshake.query.token`. Don't "fix" this to `auth` later
// without checking the backend's socket.io version first.
import Vue from 'vue'
import io from 'socket.io-client'

let socket = null

export function getSocket() {
  return socket
}

export function connectSocket() {
  if (socket && socket.connected) return socket

  const userToken = Vue.$cookies.get('userToken')
  if (!userToken) return null

  if (socket) {
    socket.disconnect()
    socket = null
  }

  socket = io(process.env.VUE_APP_API_URL, {
    query: { token: userToken },
    // Polling is stateful and fails with "Session ID unknown" on the current
    // PM2/proxy setup unless sticky sessions are configured. Only use a pure
    // WebSocket transport when sockets are explicitly enabled.
    transports: ['websocket'],
    reconnection: true,
    reconnectionDelay: 2000,
    reconnectionAttempts: 3,
  })

  return socket
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}
